var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8826 0.5L17.2016 7.86365L25.5885 9.66718L19.8709 16.0217L20.7353 24.5L12.8826 21.0637L5.02997 24.5L5.8944 16.0217L0.176758 9.66718L8.56367 7.86365L12.8826 0.5Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02997 24.5L12.8826 21.0637V0.5L8.56367 7.86365L0.176758 9.66718L5.8944 16.0217L5.02997 24.5Z",
    fill: "#FFCB45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.c25328b49c26b2e26428684c8ae56c55.svg";
export { ForwardRef as ReactComponent };